import React from 'react';
import { message, Modal } from 'antd';


/**
 * @class		BasicAbstract							Basic抽象组件
 * @ctime 	2018-04-16 10:30:21
 * @method	toggleCurrentModal				打开关闭编辑Modal
 * @method	toggleImportModal					打开关闭上传Modal
 * @method	publicHandle							自定义数据处理方式
 */
export default class BasicAbstract extends React.Component {

	handleError = message => console.error(message)

	toggleCurrentModal = () => this.setState({
		currentModalStatus: !this.state.currentModalStatus
	})

	toggleImportModal = () => {
		if(this.state.importModalStatus){
			this.publicChange()
		}
		this.setState({
			importModalStatus: !this.state.importModalStatus
			
		})}

	publicChange = () => this.handleError("Public change action is not implemented")

	publicCreate = () => this.handleError("Public create action is not implemented")

	publicUpdate = () => this.handleError("Public update action is not implemented")

	publicDelete = () => this.handleError("Public delete action is not implemented")

	publicSubmit = () => this.handleError("Public submit action is not implemented")

	publicExport = () => this.handleError("Public export action is not implemented")

	dataSource = () => this.handleError("Data source action is not implemented")

	publicHandle = config => {
		if ("function" !== typeof config.callee) {
			this.handleError("Child custom callee method is required!");
			return;
		}
		if (config.alert) {
			Modal.confirm({
				title: '确定' + config.title + "么?",
				okText: '确认',
				cancelText: '取消',
				onOk: () => this.publicHandleAction(config),
				onCancel: () => {}
			});
		}else{
			this.publicHandleAction(config);
		}
	}

	publicHandleAction = config => {
		config.callee(config.data, res => {
			if (200 === res.status) {
				if (undefined === res.data.Success || res.data.Success) {
					if (config.alert) {
						message.success(config.title + "成功", 4);				
					}
					if ("function" === typeof config.callback) {
						config.callback(res);
					}
				}else{
					message.error(config.title + "失败, " + res.data.Errors[0], 4);
				}
			}else{
				message.error(config.title + "失败, " + res.data.Errors[0], 4);
			}
		}, err => message.error(config.title + "失败, 请联系管理员", 4))
	}
}












// WEBPACK FOOTER //
// ./src/components/abstract/Basic.abstract.js